import React from 'react';
import { MediaRenderer } from './DataComponent';
import { posters } from '../data/posters';
import './PosterPage.css';
import { useParams } from 'react-router-dom';

const DataComponentPage: React.FC = () => {
    const { id, data_id } = useParams();
    const poster = posters.find(p => p.id === id);
    const dataItem = poster?.dataItems.find(item => item.id === data_id);

    if (!poster) {
        return <div>Poster not found</div>;
    }
    if (!dataItem) {
        return <div>Data item not found</div>;
    }
    return (
        <div className="poster-page">
            <div className="poster-header">
                <h1>{dataItem.title}</h1>
            </div>
            <p className="poster-description">{dataItem.description}</p>
            <div className="poster-content">
                <MediaRenderer data={dataItem.data} title={dataItem.title} />
            </div>
        </div>
    );
};

export default DataComponentPage; 